import React, { useEffect } from "react";
import MainIntro from "./main-intro";
import SidebarActionButtons from "../sidebar-action-buttons";
import MainOption from "./main-option";
import { CUSTOMISATION_OPTIONS } from "../../constants/all-customisation-options";
import { useDispatch } from "react-redux";
import { resetCustomisationState } from "../../customisation-slice";
import Button from "../button";
import { useWatchViewContext } from "../../providers/watch-view-provider";
import { useSidebarAnimationContext } from "../../providers/sidebar-animation-provider";
import { useDialogContext } from "../../providers/dialog-provider";
import { DialogTypes } from "../../constants/dialog-types";

const MainOptionsContainer = () => {
  const dispatch = useDispatch();

  const { goToSpecificView } = useWatchViewContext();
  const { openDialog, closeDialog } = useDialogContext();
  const {
    updateEditStateWithAnimation,
    updateFinishedEditingStateWithAnimation,
  } = useSidebarAnimationContext();

  const goToFirstViewIndex = () => goToSpecificView(0);

  const startOver = () => {
    dispatch(resetCustomisationState());
    goToFirstViewIndex();
    closeDialog();
  };

  useEffect(() => {
    goToFirstViewIndex();
  }, []);

  const actionButtons = [
    <Button
      key="Finish"
      label="Finish"
      onClick={() => updateFinishedEditingStateWithAnimation(true)}
      icon="Tick"
    />,
    <Button
      key="Start Over"
      label="Start Over"
      onClick={() =>
        openDialog({
          type: DialogTypes.CONFIRMATION,
          title: "Start Over?",
          description:
            "All of your customisations will be removed. Are you sure you want to start over?",
          onSubmit: startOver,
          onClose: closeDialog,
        })
      }
      outline={true}
      icon="Restart"
    />,
  ];

  return (
    <>
      <MainIntro />
      <div className="flex-grow flex flex-row md:grid grid-cols-2 overflow-y-auto">
        {Object.keys(CUSTOMISATION_OPTIONS).map((key) => {
          const option = CUSTOMISATION_OPTIONS[key];
          return (
            <MainOption
              key={option.title}
              title={option.title}
              iconName={option.iconName}
              onClick={() => updateEditStateWithAnimation(key)}
            />
          );
        })}
      </div>
      <SidebarActionButtons buttons={actionButtons} />
    </>
  );
};

export default MainOptionsContainer;
